<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row  >
					<el-col :span="6">
						<el-form-item label="校名">
							<el-input v-model="searchParams.name" placeholder="模糊搜索"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="合作程度">
							<el-select v-model="searchParams.rank"  @change="list"
										placeholder="请选择">
										<el-option v-for=" itm  in  [{nm:'全部',rank:'0'},{nm:'没合作',rank:'1'},{nm:'有合作3星+',rank:'3'},{nm:'密切合作5星',rank:5}]" :key="itm.rank"
											:label="itm.nm" :value="itm.rank">
										</el-option>
									</el-select>
						</el-form-item>
					</el-col>
				 
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
            <el-button type="primary" icon="el-icon-plus" @click="toSave()">添加</el-button>
        </div>
        <div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange" v-loading="listLoading">
						<el-table-column type="selection" width="55" fixed="left"></el-table-column>
						<el-table-column width="180px"  prop="name" label="名称"></el-table-column>
						<el-table-column width="65px" prop="benke" label="有本科">
                              <template slot-scope="scope">
                                {{scope.row.benke?"有":""}}
                             </template>
						</el-table-column>
						<el-table-column width="65px" prop="dazuan" label="有大专">
                             <template slot-scope="scope">
                                {{scope.row.dazuan?"有":""}}
                             </template>
						</el-table-column>
						<el-table-column width="65px" prop="zhzhuan" label="有中职">
                             <template slot-scope="scope">
                                {{scope.row.zhzhuan?"有":""}}
                             </template>
						</el-table-column>
						<el-table-column  width="65px" prop="type" label="性质">
                             <template slot-scope="scope">
                                {{scope.row.type==1?"公办":"民办"}}
                             </template>
						</el-table-column>
						<el-table-column width="160px" prop="rank" label="评级">
                             <template slot-scope="scope">
                                <el-rate v-model="scope.row.rank"  disabled> </el-rate>
                             </template>
						</el-table-column>
						<el-table-column prop="addrss" label="地址"></el-table-column>
				<el-table-column label="操作" fixed="right" width="260px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button v-has-permission-code-and="'100000000005'" size="mini"   @click="toDetail(scope.$index, scope.row)">详情</el-button>
						    <el-button v-has-permission-code-and="'100000000020'" size="mini"   @click="toUpdate(scope.$index, scope.row)">编辑</el-button>
                            <el-button v-has-permission-code-and="'100000000025'" size="mini"   @click="toTeacher( scope.row)">渠道</el-button>
                            <el-button v-has-permission-code-and="'100000000015'" size="mini"   type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
                        </div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination 
				@size-change="sizeChange" 
				@current-change="currentChange" 
				:total="listData.total" 
				:page-size="page.size"
				:current-page="page.current" 
				:layout="this.$constant.page.layout" 
				:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"  @flush="list()" ></edit>
		<collegesteacher ref="collegesteacher"></collegesteacher>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/consu/colleges/colleges.js';
import collegesteacher from "@/views/consu/collegesteacher/list.vue";
 
export default {
	name: 'colleges',
	components: {
		edit,
		collegesteacher
	},
	data() {
		return {
			searchParams: {rank:'0'},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加');
		},	//去渠道
		toTeacher(row) {
			this.$refs.collegesteacher.open(row, '渠道联系人');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
						ids: this.selected
					},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
</style>

